/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Spaces_Gallery_Desc_Businesscentral1Inputs */



/**
* | output |
* | --- |
* | "Customers, items and documents from Business Central." |
*
* @param {Spaces_Gallery_Desc_Businesscentral1Inputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
const spaces_gallery_desc_businesscentral1 = /** @type {((inputs?: Spaces_Gallery_Desc_Businesscentral1Inputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Spaces_Gallery_Desc_Businesscentral1Inputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "de") return /** @type {LocalizedString} */ ("Kunden, Artikel und Belege aus Business Central.")
	return /** @type {LocalizedString} */ ("Customers, items and documents from Business Central.")
});
export { spaces_gallery_desc_businesscentral1 as "spaces_gallery_desc_businessCentral" }